/**
 * タブ切り替え機能
 *
 * @param {string} className 対象となるタブコンテナのクラス名
 * 同じ親要素内でタブとコンテンツを連動させ、クリック時に表示を切り替えます。
 */
export function tabSwitch(className) {
	// タブとコンテンツを含むコンテナを取得
	const tabContainers = document.querySelectorAll(`.${className}`);

	// 対象のコンテナが存在しない場合は終了
	if (!tabContainers.length) return;

	tabContainers.forEach(container => {
		// 各コンテナ内のタブとコンテンツを取得
		const tabs = container.querySelectorAll(`.${className}__tab`);
		const contents = container.querySelectorAll(`.${className}__content`);

		// コンテンツに連番の属性を付与
		contents.forEach((content, index) => {
			content.dataset.tab = `tab-${index}`;
		});

		// 各タブにクリックイベントを設定
		tabs.forEach((tab, index) => {
			tab.addEventListener('click', () => {
				// クリックされたタブをアクティブに変更
				tabs.forEach(t => t.classList.remove('active'));
				tab.classList.add('active');

				// 対応するコンテンツを表示
				contents.forEach(content => {
					content.classList.remove('active');
				});

				const targetContent = container.querySelector(`[data-tab="tab-${index}"]`);
				if (targetContent) {
					targetContent.classList.add('active');
				}
			});
		});

		// 初期表示設定: 最初のタブとコンテンツをアクティブにする
		if (tabs.length && contents.length) {
			tabs[0].classList.add('active');
			contents[0].classList.add('active');
		}
	});
}
